// removed by extract-text-webpack-plugin
module.exports = {"spinner":"_2TwlA8inRvZP250bCDt04X","inButton":"_9nNrxGMOXfKieP-0HpeFx","visible":"_2Dr1SH33LwMiSYyH7RP7hG"};


//////////////////
// WEBPACK FOOTER
// ./src/elements/spinner/spinner.scss
// module id = 430
// module chunks = 0